/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { toZonedTime, format } from "date-fns-tz";
import { useSettings } from "./settings-context/settingsContext";

export const useFormattedUtils = () => {
  const { settings } = useSettings(); // ✅ Allowed inside a hook

  // Format date function
  const formatDateUS = (
    date?: string | number | Date | null,
    zone: boolean = false
  ): string => {
    if (!date) return "-";

    const dateFormat = settings.dateFormat || "MMM dd, yyyy"; // Get from settings
    const timeZone = settings.timeZone || "America/New_York"; // Get from settings

    try {
      const parsedDate = new Date(date);
      const zonedDate = zone ? toZonedTime(parsedDate, timeZone) : parsedDate; // Use system timezone if zone=false

      return format(zonedDate, dateFormat);
    } catch (error) {
      console.error("Invalid date:", date);
      return "-";
    }
  };

  // Format time function
  const formatTimeUS = (
    date?: string | number | Date | null,
    zone: boolean = false
  ): string => {
    if (!date) return "-";

    const timeFormat = settings.timeFormat || "hh:mm a"; // Get from settings
    const timeZone = settings.timeZone || "America/New_York"; // Get from settings

    try {
      const parsedDate = new Date(date);
      const zonedDate = zone ? toZonedTime(parsedDate, timeZone) : parsedDate; // Use system timezone if zone=false

      return format(zonedDate, timeFormat);
    } catch (error) {
      console.error("Invalid time:", date);
      return "-";
    }
  };

  return { formatDateUS, formatTimeUS };
};

export function formatToAMPM(timeStr: any) {
  if (!timeStr) return ""; // handle undefined
  const [hoursStr, minutesStr] = timeStr.split(":");
  let hours = Number(hoursStr);
  const minutes = Number(minutesStr);
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // convert 0 -> 12
  return `${hours}:${String(minutes).padStart(2, "0")} ${ampm}`;
}
